module.exports = __webpack_public_path__ + "img/monitorS.8e63211e.png";